export default "__VITE_ASSET__58d1db2f__"